// src/components/CompanyDetail.js
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanyById } from "../features/companyDetailSlice";
import "./CompanyDetail.css";

function CompanyDetail() {
  const { companyId } = useParams();
  const dispatch = useDispatch();
  const { companyById, loading, error } = useSelector(
    (state) => state.companyDetail
  );
  const companyData = companyById[companyId];

  useEffect(() => {
    dispatch(fetchCompanyById(companyId));
  }, [dispatch, companyId]);

  if (loading) return <div>Loading company...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!companyData) return <div>No company found for {companyId}.</div>;

  // Destructure whatever fields exist in your Firestore doc
  const {
    name,
    industry,
    location,
    stage,
    investors = [],
    female_founded,
    early_stage,
    exits_risk,
    recent_fund_raise,
  } = companyData;

  return (
    <div className="company-detail-container">
      {/* Header */}
      <header className="company-detail-header">
        <h1>{name}</h1>
        <p className="company-subtitle">
          Document ID: <strong>{companyId}</strong>
        </p>
      </header>

      {/* Basic Info Section */}
      <section className="company-details">
        <p><strong>Industry:</strong> {industry || "N/A"}</p>
        <p><strong>Location:</strong> {location || "N/A"}</p>
        <p><strong>Stage:</strong> {stage || "N/A"}</p>
        <p><strong>Female Founded:</strong> {female_founded ? "Yes" : "No"}</p>
        <p><strong>Early Stage:</strong> {early_stage ? "Yes" : "No"}</p>
        <p><strong>Exits Risk:</strong> {exits_risk || "N/A"}</p>
        <p><strong>Recent Fund Raise:</strong> {recent_fund_raise ? "Yes" : "No"}</p>
      </section>

      {/* Investors Section */}
      <section className="company-investors">
        <h2>Investors</h2>
        {investors.length > 0 ? (
          <ul>
            {investors.map((inv, idx) => (
              <li key={idx}>{inv}</li>
            ))}
          </ul>
        ) : (
          <p>No investors listed.</p>
        )}
      </section>
    </div>
  );
}

export default CompanyDetail;
